import React from 'react';
import Select from '../../../components/ui/Select';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const FilterSidebar = ({
  filters,
  users,
  categories,
  onFilterChange,
  onClearFilters,
  onSavePreset
}) => {
  const statusOptions = [
    { value: '', label: 'All Statuses' },
    { value: 'active', label: 'Active' },
    { value: 'spare', label: 'Spare' },
    { value: 'repair', label: 'Repair' },
    { value: 'retired', label: 'Retired' }
  ];

  const typeOptions = [
    { value: '', label: 'All Types' },
    ...(categories || []).map(category => ({
      value: category.id,
      label: category.name
    }))
  ];

  const departmentOptions = [
    { value: '', label: 'All Departments' },
    { value: 'IT', label: 'IT' },
    { value: 'HR', label: 'HR' },
    { value: 'Finance', label: 'Finance' },
    { value: 'Marketing', label: 'Marketing' }
  ];

  const ownerOptions = [
    { value: '', label: 'All Owners' },
    ...(users || []).map(user => ({
      value: user.id,
      label: user.name
    }))
  ];

  const hasActiveFilters = Object.values(filters).some(value => value !== '' && value !== null && value !== undefined);

  return (
    <div className="w-80 bg-card border-r border-border p-6 space-y-6">
      <div className="flex items-center justify-between">
        <h3 className="text-lg font-semibold text-card-foreground">Filters</h3>
        {hasActiveFilters && (
          <Button variant="ghost" size="sm" onClick={onClearFilters} iconName="X" iconPosition="left">
            Clear
          </Button>
        )}
      </div>

      <div className="space-y-4">
        <Select
          label="Status"
          options={statusOptions}
          value={filters?.status || ''}
          onChange={(value) => onFilterChange('status', value)}
        />

        <Select
          label="Asset Type"
          options={typeOptions}
          value={filters?.asset_category_id || ''}
          onChange={(value) => onFilterChange('asset_category_id', value)}
        />

        <Select
          label="Department"
          options={departmentOptions}
          value={filters?.department || ''}
          onChange={(value) => onFilterChange('department', value)}
        />

        <Select
          label="Owner"
          options={ownerOptions}
          value={filters?.owner_id || ''}
          onChange={(value) => onFilterChange('owner_id', value)}
          searchable
        />
      </div>
    </div>
  );
};

export default FilterSidebar;